import { useState } from "react";
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    Paper,
    Stack,
    TextField,
    Typography
} from "@mui/material";

import {
    Visibility,
    VisibilityOff
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

export default function LoginForm() {

    const navigate = useNavigate();

    const { login } = useAuth();

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [showPassword, setShowPassword] =
        useState(false);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState("");

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        setError("");

        try {

            await login(

                email,

                password

            );

            navigate("/");

        }

        catch (err) {

            setError(

                err.response?.data?.message ||

                "Login failed"

            );

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <Paper

            elevation={5}

            sx={{

                width: 420,

                p: 5,

                borderRadius: 4

            }}

        >

            <Typography

                variant="h4"

                fontWeight="bold"

                gutterBottom

            >

                U2USYSTEMS

            </Typography>

            <Typography

                color="text.secondary"

                sx={{ mb: 4 }}

            >

                Knowledge Hub

            </Typography>

            {

                error && (

                    <Alert

                        severity="error"

                        sx={{ mb: 3 }}

                    >

                        {error}

                    </Alert>

                )

            }

            <Box

                component="form"

                onSubmit={handleSubmit}

            >

                <Stack spacing={3}>

                    <TextField

                        label="Email"

                        fullWidth

                        value={email}

                        onChange={(e) =>

                            setEmail(e.target.value)

                        }

                    />

                    <TextField

                        label="Password"

                        type={

                            showPassword

                                ? "text"

                                : "password"

                        }

                        fullWidth

                        value={password}

                        onChange={(e) =>

                            setPassword(e.target.value)

                        }

                        InputProps={{

                            endAdornment:

                                <InputAdornment

                                    position="end"

                                >

                                    <IconButton

                                        onClick={() =>

                                            setShowPassword(

                                                !showPassword

                                            )

                                        }

                                    >

                                        {

                                            showPassword

                                                ?

                                                <VisibilityOff />

                                                :

                                                <Visibility />

                                        }

                                    </IconButton>

                                </InputAdornment>

                        }}

                    />

                    <Button

                        type="submit"

                        variant="contained"

                        size="large"

                        disabled={loading}

                    >

                        {

                            loading

                                ?

                                <CircularProgress

                                    size={22}

                                    color="inherit"

                                />

                                :

                                "Login"

                        }

                    </Button>

                </Stack>

            </Box>

        </Paper>

    );

}